export default __webpack_public_path__ + "static/media/resellers.55ec9d17.svg";